import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.0",
  viewBox: "0 0 3840 2160"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#006ce3",
      d: "M1999.5 125.7c-118.2 38.8-215.1 70.6-215.2 70.6 0 .1-15.7 71.3-34.7 158.2-19.1 86.9-34.9 158.8-35.2 159.7-.5 1.7-8.6 1.8-146.7 2l-146.1.3-31.3 146.5c-17.1 80.6-31.2 147.1-31.3 147.7 0 1 30.2 1.3 146.3 1.5l146.3.3-62.3 285c-34.2 156.7-64.5 295.8-67.2 309-27.4 132-37.2 214.8-35.8 302 .7 43.4 3.4 70.9 10.4 104 32.5 155.4 136.2 249 311.3 281 23.6 4.3 44.8 6.9 80.5 10 7.2.6 38.4 1.7 56 1.9 37.6.5 74.1-3.7 129-14.9 23.4-4.8 95.3-21 95.9-21.6.3-.3 52.5-235.8 67.6-304.6l1.8-8.2-5.2 2c-37.8 15-84.8 25.9-135.6 31.4-22.6 2.5-65.8 3.1-80.5 1.1-37-5-65.7-18.7-88.8-42.5-19-19.6-30-41.1-36.5-71-2.6-12.3-2.7-13.4-2.6-44.6.1-42.1 3.7-77.2 11.8-115.5 5.2-24.6 152.7-702.3 153.2-704.3.5-1.6 10-1.7 181.3-1.7h180.8l2.7-12.8c1.5-7 15.7-73.2 31.5-147.2l28.7-134.5-180.6-.5c-179.7-.5-180.5-.5-180.3-2.5.1-1.1 22.3-104.3 49.2-229.3 27-125 49.1-227.7 49.1-228.3 0-.5-.6-.9-1.2-.8-.7 0-98 31.8-216.3 70.6"
    }, null, -1)
  ])))
}
export default { render: render }